import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from "components/shared-components/Loading";

const AssinaturaPage = lazy(() => import("./AssinaturaPage"));
const ValidarTokenPage = lazy(() => import("./ValidarTokenPage"));

export function AssinaturaViews() {
	return (
		<div style={{ minHeight: "100vh", background: "#f0f2f5" }}>
			<Suspense fallback={<Loading cover="page" />}>
				<Switch>
					{/* Rota de validação do token enviado por e-mail — deve vir antes da rota genérica */}
					<Route path="/assinatura/:chave/validar/:token" component={ValidarTokenPage} />
					<Route path="/assinatura/:chave" component={AssinaturaPage} />
					<Redirect from="/assinatura" to="/auth/welcome" />
				</Switch>
			</Suspense>
		</div>
	);
}

export default AssinaturaViews;
